import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-thirtyeighty-download',
    templateUrl: './thirtyeighty-download.component.html',
    styleUrls: ['./thirtyeighty-download.component.css'],
    standalone: false
})
export class ThirtyEightyDownloadComponent implements OnInit {
  title:any;
  constructor() { }

  ngOnInit() {
    this.title = "GSA 3080 File Download";
  }

}
